<template>
    <div class="text-center gray-600 f-110" v-b-tooltip.hover :title="pipeline_title">
        
        <template v-if="prev_sub_info.is_prev_version">
            <div>
                {{ $t(`'해당없음' 처리된 과거답변입니다.`) }}
            </div>
        </template>
        <template v-else>
            <div>
                {{ $t('이전 문항') }}:
                <a class="text-underline cursor" style="color: unset"
                    @click="make_question_route"
                    >
                    <template v-if="get_question_name"> {{ get_question_name }} - </template> {{ sub_label }}
                </a>
            </div>
            <div>
                {{ $t(`이전 문항의 답변 내용에 따라 '해당없음' 처리되었습니다.`) }} <br> {{ $t(`다음 문항으로 이동해주세요.`) }}
            </div>
        </template>
        
    </div>
</template>

<script>
import { mapState } from "vuex";
import * as th from 'tree-helper'

export default {
    name: 'DFPipelineOverlay',
    props: {
        prev_sub_info: {
            type: Object,
            default: () => ({
                is_prev_version: false,
                sub_code: null,
                label: null,
                question_info: {
                    question_name: null,
                    question_name_c: null,
                    question_name_e: null,
                    question_code: null,
                }
            })
        },
        pipeline_title: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapState(['template_in_progress']),
        get_question_name () {
            if (!this.prev_sub_info.question_info?.question_name) {
                return null
            }

            const { question_name, question_name_e, question_name_c } = this.prev_sub_info.question_info
            return this.$i18n.locale === 'en' ? question_name_e : this.$i18n.locale === 'ca' ? question_name_c : question_name
        },
        sub_label(){
            return this.prev_sub_info.label ?? this.prev_sub_info.sub_code
        }
    },
    methods: {
        make_question_route(){
            if (this.$route.path.includes('answers')) {
                this.$EventBus.$emit('Answers-pipeline_overlay_question_clicked', {
                    question_code: this.prev_sub_info.question_info.question_code
                })
            } else if(this.$route.path.includes('questions')) {
                let targetQuestion = null
                
                th.depthFirstSearch(this.template_in_progress.template_contents, (node)=> {
                    if(node?.question_code === this.prev_sub_info.question_info.question_code){
                        targetQuestion = node
                    }
                })
                if(targetQuestion){
                    this.$EventBus.$emit('Questions-pipeline_overlay_question_clicked', targetQuestion)
                }
            }
        }
    }
}
</script>

